import Parse from "papaparse";
import { saveAs } from "file-saver";

export const downloadCsv = (data, filename) => {
  const blob = new Blob([Parse.unparse(data)], {
    type: "text/plain;charset=utf-8",
  });

  saveAs(blob, `${filename}.csv`);
};
